/* PTB Atelier — textes de l'assistant en ESPAGNOL, ALLEMAND, ITALIEN et NÉERLANDAIS + noms des fils.
   Fichier généré par tools/i18n/gen_atelier.py (sources : _src/strings/atelier_latin.py). Chargé après ptb-atelier-i18n-v3.js ; le français reste la langue de repli. */
(function () {
  'use strict';
  var A = window.PTBAtelier;
  if (!A || !A.i18n || !A.i18n.dict) return;
  var D = A.i18n.dict;
  D.es = {
   "common.back": "Atrás",
   "common.next": "Continuar",
   "common.close": "Cerrar",
   "common.loading": "Cargando…",
   "common.remove": "Quitar",
   "common.retry": "Reintentar",
   "common.optional": "opcional",
   "common.restart": "Empezar de nuevo",
   "progress.label": "Pasos de tu solicitud",
   "progress.step": "Paso {n} de {total}",
   "step.1": "Artículo",
   "step.2": "Talla y color",
   "step.3": "Personalización",
   "step.4": "Hilos",
   "step.5": "Resumen",
   "step1.title": "Elige tu artículo.",
   "step1.sub": "Selecciona una o varias prendas. Solo se muestran los artículos disponibles, al precio de la tienda: el bordado está incluido, sin recargo.",
   "step1.categories": "Categorías",
   "step1.all": "Todo",
   "step1.search": "Buscar un artículo",
   "step1.from": "Desde {price}",
   "step1.add": "Elegir",
   "step1.added": "Elegido",
   "step1.none": "Ningún artículo coincide con tu búsqueda.",
   "step1.selected": "{n} artículo seleccionado||{n} artículos seleccionados",
   "step1.empty": "Elige al menos un artículo para continuar.",
   "step1.catalogError": "No se han podido cargar los artículos en este momento.",
   "step1.addError": "No se ha podido añadir este artículo. Inténtalo de nuevo en un momento.",
   "cat.sweat": "Sudaderas",
   "cat.tshirt": "Camisetas",
   "cat.polo": "Polos",
   "cat.headwear": "Gorras y gorros",
   "cat.bag": "Bolsos",
   "cat.baby": "Bebé",
   "cat.other": "Otros",
   "step2.title": "Selecciona tu talla y tu color.",
   "step2.sub": "Para cada artículo, indica la talla, el color y la cantidad. Los precios mostrados son los de la tienda.",
   "opt.color": "Color",
   "opt.size": "Talla",
   "opt.qty": "Cantidad",
   "opt.single": "Modelo único: aquí no hay nada que elegir.",
   "step2.chooseColor": "Elige un color",
   "step2.chooseSize": "Elige una talla",
   "step2.unavailable": "Esta combinación no está disponible.",
   "step2.incomplete": "Elige la talla y el color de cada artículo para continuar.",
   "step2.incompleteShort": "Por completar",
   "step2.removeItem": "Quitar este artículo",
   "step2.addLine": "Añadir otra talla o color",
   "price.unit": "Precio unitario",
   "price.subtotal": "Subtotal de artículos",
   "price.discount": "Descuento",
   "price.shipping": "Envío (estimado)",
   "price.total": "Total estimado",
   "price.calc": "calculando…",
   "price.toConfirm": "por confirmar",
   "price.free": "Gratis",
   "price.freeShipping": "Envío gratuito a todo el mundo",
   "price.remaining": "Solo te faltan {amount} para disfrutar del envío gratuito a todo el mundo",
   "price.thresholdOther": "Envío gratuito a todo el mundo a partir de {amount} de compra, según las condiciones de la tienda.",
   "price.note": "Estimación: precio de la tienda, bordado incluido, sin recargo ni descuento de pack. El precio final y el envío se confirman al pagar.",
   "price.unavailable": "La estimación del envío no está disponible momentáneamente.",
   "summary.title": "Mi solicitud",
   "summary.empty": "Todavía no has elegido ningún artículo.",
   "summary.count": "{n} prenda||{n} prendas",
   "sum.design": "Personalización",
   "sum.text": "Texto",
   "sum.image": "Imagen",
   "sum.threads": "Hilos",
   "sum.none": "Por definir",
   "restore.notice": "Hemos recuperado tu solicitud en curso.",
   "preselect.notice": "Artículo añadido desde la ficha del producto.",
   "preselect.unavailable": "Este artículo no está disponible para la personalización.",
   "step3.title": "Añade tu texto o tu imagen.",
   "step3.sub": "Elige una sola opción: texto o imagen. La vista previa es orientativa.",
   "step3.typeLabel": "Tipo de personalización",
   "step3.tabText": "Texto",
   "step3.tabImage": "Imagen",
   "step3.typeTextHelp": "Un nombre, una palabra, una fecha…",
   "step3.typeImageHelp": "Un logotipo o un dibujo (PNG o JPG)",
   "step3.textLabel": "Tu texto",
   "step3.textHelp": "{max} caracteres como máximo. Letras, números y puntuación sencilla.",
   "step3.counter": "{n}/{max}",
   "step3.textPlaceholder": "Ej.: Yanis",
   "step3.fontLabel": "Fuente del bordado",
   "step3.unsupported": "Algunos caracteres no son compatibles (emojis, símbolos) y se han eliminado.",
   "step3.imageLabel": "Tu imagen",
   "step3.drop": "Arrastra tu imagen aquí",
   "step3.or": "o",
   "step3.pick": "Elegir un archivo",
   "step3.imageRules": "PNG o JPG · {max} MB como máximo · {min} px como mínimo en el lado más largo",
   "step3.imageTips": "Elige preferiblemente un logotipo o un dibujo nítido, sencillo y con pocos colores. Las fotos, los degradados y las imágenes muy detalladas son difíciles de bordar: el equipo de PTB te dirá si tu diseño es realizable.",
   "step3.imageNotProd": "Tu archivo sirve de referencia: no se utiliza tal cual para la producción, el equipo lo adapta al bordado.",
   "step3.replace": "Reemplazar",
   "step3.delete": "Eliminar",
   "step3.fileInfo": "{name} · {w}×{h} px · {size}",
   "step3.imageBusy": "Leyendo la imagen…",
   "step3.previewTitle": "Vista previa orientativa",
   "step3.previewNote": "Vista previa orientativa: el resultado bordado puede diferir ligeramente (tamaño, finura de los detalles, color de los hilos).",
   "step3.emptyPreview": "Tu texto",
   "step3.placementTitle": "Ubicación del bordado",
   "step3.placementFor": "Ubicación en {item}",
   "step3.sideNote": "Izquierda y derecha: desde el punto de vista de la persona que lleva la prenda.",
   "step3.sameDesign": "El mismo motivo se borda en cada artículo de tu solicitud. Puedes elegir una ubicación distinta para cada tipo de artículo.",
   "step3.instrLabel": "Instrucciones adicionales",
   "step3.instrHelp": "Retoques, precisiones sobre la ubicación, detalles que respetar…",
   "step3.needType": "Elige un texto o una imagen para continuar.",
   "step3.needText": "Escribe tu texto para continuar.",
   "step3.needImage": "Añade una imagen válida para continuar.",
   "step3.needPlacement": "Elige una ubicación para cada artículo.",
   "pl.chest_left": "Pecho izquierdo",
   "pl.chest_right": "Pecho derecho",
   "pl.chest_center": "Pecho centro",
   "pl.back": "Espalda",
   "pl.sleeve_left": "Manga izquierda",
   "pl.sleeve_right": "Manga derecha",
   "pl.front": "Parte delantera",
   "pl.side_left": "Lado izquierdo",
   "pl.side_right": "Lado derecho",
   "pl.back_cap": "Parte trasera",
   "pl.custom": "Otra (por precisar)",
   "err.imgType": "Formato no compatible. Utiliza un archivo PNG o JPG.",
   "err.imgSvg": "Los archivos SVG no se aceptan por motivos de seguridad. Exporta tu dibujo en PNG.",
   "err.imgSize": "Archivo demasiado pesado ({size}). Máximo: {max}.",
   "err.imgSmall": "Imagen demasiado pequeña ({w}×{h} px). Mínimo: {min} px en el lado más largo.",
   "err.imgLarge": "Imagen demasiado grande en dimensiones (máximo {max} px).",
   "err.imgCorrupt": "No se puede leer este archivo. Comprueba que sea una imagen PNG o JPG intacta.",
   "err.imgMismatch": "El contenido del archivo no corresponde a su formato.",
   "step4.title": "Elige los colores de tu bordado.",
   "step4.sub": "Selecciona de 1 a {max} colores de hilo. Los colores que se muestran en pantalla son orientativos.",
   "step4.palette": "Paleta de hilos",
   "step4.count": "{n}/{max} color elegido||{n}/{max} colores elegidos",
   "step4.selected": "Tus colores de hilo",
   "step4.none": "Todavía no has elegido ningún color.",
   "step4.max": "Máximo alcanzado: {max} colores. Quita un color para elegir otro.",
   "step4.need": "Elige al menos un color de hilo para continuar.",
   "step4.noteText": "El primer color es el de las letras. El segundo, si eliges uno, se usa como contorno en la vista previa.",
   "step4.noteImage": "En el caso de una imagen multicolor, el equipo de PTB confirma el resultado final y el número de colores de hilo.",
   "step4.indicative": "Los tonos en pantalla son orientativos: los hilos reales pueden variar ligeramente.",
   "step4.code": "Ref. {code}",
   "step4.removeOne": "Quitar {name}",
   "step5.title": "Revisa y envía tu solicitud.",
   "step5.sub": "Repasa tu proyecto. Una vez enviada tu solicitud, la validas en el pago seguro de Shopify: nuestro equipo la tramita después de esa validación.",
   "step5.subReq": "Repasa tu proyecto. Se trata de una solicitud de personalización: ahora no se te pide ningún pago.",
   "step5.afterSend": "Tras el envío, pasas al pago seguro de Shopify para validar tu solicitud. Los precios son los de la tienda, sin recargo por el bordado y sin descuento de pack.",
   "step5.markerNote": "En el pago verás una línea «Atelier PTB — Personalización bordada (sin recargo)» de 0 €: es el seguimiento de tu solicitud y no añade nada al precio de tus artículos.",
   "step5.preparing": "Preparando el pago…",
   "step5.sendShort": "Enviar",
   "step5.items": "Tu artículo y su personalización",
   "step5.design": "Tu personalización",
   "step5.designText": "Texto: «{text}»",
   "step5.designImage": "Imagen: {name}",
   "step5.fontL": "Fuente",
   "step5.threadsL": "Hilos de bordado",
   "step5.placementL": "Ubicación",
   "step5.instrL": "Instrucciones",
   "step5.edit": "Modificar",
   "step5.contact": "Tus datos de contacto",
   "f.first": "Nombre",
   "f.last": "Apellidos",
   "f.email": "Correo electrónico",
   "f.phone": "Teléfono (opcional)",
   "f.message": "Mensaje para el equipo (opcional)",
   "f.messageHelp": "Una precisión, una fecha deseada, una pregunta…",
   "step5.shipTo": "Envío estimado a: {country}. Puedes cambiar de país desde el menú del sitio.",
   "step5.consent": "Confirmo que esta información es exacta y que tengo derecho a utilizar el texto o la imagen facilitados. Entiendo que mi solicitud se validará en el pago seguro de Shopify.",
   "step5.consentReq": "Confirmo que esta información es exacta y que tengo derecho a utilizar el texto o la imagen facilitados. Entiendo que se trata de una solicitud y no de un pedido: ahora no se me pide ningún pago.",
   "step5.privacy": "Tus datos de contacto, tu proyecto y tu archivo se utilizan únicamente para tramitar tu solicitud. El archivo se conserva en un espacio privado, al que solo accede el equipo de PTB,",
   "step5.privacyText": "Tus datos de contacto y tu proyecto se utilizan únicamente para tramitar tu solicitud.",
   "step5.retention": "y se elimina transcurrido {n} mes.||y se elimina transcurridos {n} meses.",
   "step5.privacyLink": "Política de privacidad",
   "step5.send": "Enviar mi solicitud",
   "step5.sending": "Enviando…",
   "step5.previewMode": "Modo vista previa: el envío está desactivado hasta que se configure el servicio de recepción de solicitudes. No se enviará nada.",
   "step5.disabled": "El envío de solicitudes todavía no está disponible. No se ha enviado ninguna solicitud.",
   "err.first": "Indica tu nombre.",
   "err.last": "Indica tus apellidos.",
   "err.email": "Indica una dirección de correo electrónico válida.",
   "err.phone": "Este número de teléfono no parece válido.",
   "err.consent": "Marca la casilla de confirmación para enviar tu solicitud.",
   "err.stepsIncomplete": "Un paso anterior está incompleto: {step}.",
   "err.send.network": "No se puede conectar. Comprueba tu conexión: tu información se conserva, puedes volver a intentarlo.",
   "err.send.server": "El envío no se ha completado. Tu información se conserva, puedes volver a intentarlo en un momento.",
   "err.send.rate": "Demasiadas solicitudes en poco tiempo. Inténtalo de nuevo dentro de unos minutos.",
   "err.send.invalid": "No se ha podido aceptar la solicitud: {msg}",
   "err.send.spam": "El control antispam ha rechazado la solicitud. Recarga la página e inténtalo de nuevo.",
   "err.send.cart": "No se ha podido preparar el pago ({msg}). Revisa tus artículos y vuelve a intentarlo: no se ha enviado nada.",
   "err.send.contact": "Si el problema persiste, escríbenos desde la página de Contacto.",
   "err.send.contactLink": "Página de Contacto",
   "ok.title": "¡Gracias por tu solicitud de personalización!",
   "ok.body": "Hemos recibido tu proyecto. Nuestro equipo estudiará los detalles de tu bordado y se pondrá en contacto contigo por correo electrónico.",
   "ok.ref": "Referencia de tu solicitud",
   "ok.mailSent": "Acabamos de enviar un correo de confirmación a {email}. Recuerda revisar tu carpeta de spam.",
   "ok.mailSentPay": "Acabamos de enviar a {email} un correo de confirmación con el enlace para validar tu solicitud.",
   "ok.last": "Último paso: valida tu solicitud",
   "ok.lastText": "Para que podamos tramitarla, finaliza tu pedido en el pago seguro de Shopify. Precios de la tienda, sin recargo por el bordado ni descuento de pack.",
   "ok.pay": "Validar mi solicitud",
   "ok.redirect": "Redirigiendo al pago seguro…",
   "ok.mailFailed": "Tu solicitud está registrada, pero no se ha podido enviar el correo de confirmación. Guarda bien esta referencia.",
   "ok.next": "¿Y después?",
   "ok.n1": "Validas tu solicitud en el pago seguro de Shopify.",
   "ok.n2": "Nuestro equipo estudia los detalles de tu bordado: viabilidad, tamaño, colores de hilo.",
   "ok.n3": "Si hace falta alguna precisión, el equipo se pone en contacto contigo por correo electrónico.",
   "ok.q1": "El equipo estudia tu proyecto: viabilidad, tamaño del bordado, colores de hilo.",
   "ok.q2": "Recibes una respuesta por correo electrónico, con las precisiones que hagan falta.",
   "ok.q3": "No se pide ni se paga nada antes de tu confirmación.",
   "co.custom": "Personalización",
   "co.font": "Fuente",
   "co.threads": "Hilos",
   "co.place": "Ubicación",
   "co.instr": "Instrucciones",
   "co.ref": "Solicitud",
   "ok.new": "Hacer otra solicitud",
   "ok.shop": "Volver a la tienda",
   "step2.perArticle": "Cada línea es un artículo con su propia personalización en el paso siguiente. Para bordar dos motivos distintos, añade dos líneas («Añadir otra talla o color»).",
   "line.n": "Artículo {n}",
   "step3.subMulti": "Elige una personalización para cada artículo, o la misma para todos. La vista previa es orientativa.",
   "mode.label": "Alcance de la personalización",
   "mode.same": "La misma personalización para todos",
   "mode.sameHelp": "El mismo motivo en los {n} artículos.",
   "mode.each": "Una personalización por artículo",
   "mode.eachHelp": "Texto o imagen, hilos y ubicación propios de cada artículo.",
   "mode.confirmTitle": "Confirmar",
   "mode.confirm": "Las personalizaciones propias de cada artículo se sustituirán por la del artículo 1. ¿Continuar?",
   "mode.confirmYes": "Sí, aplicar a todos",
   "common.cancel": "Cancelar",
   "tabs.label": "Artículos de tu solicitud",
   "copy.label": "Copiar la personalización de otro artículo",
   "copy.labelThreads": "Copiar los hilos de otro artículo",
   "copy.choose": "Elegir un artículo…",
   "step3.scopeSame": "Esta personalización se bordará en cada uno de los {n} artículos de tu solicitud (la ubicación se puede ajustar por artículo).",
   "step3.scopeEach": "Estás personalizando: {n}.",
   "step3.qtyNote": "Cantidad: {n} — se realiza el mismo bordado en cada prenda.",
   "step3.oneDesign": "Elige la ubicación del bordado.",
   "step5.itemsMany": "Tus artículos y su personalización",
   "step5.editDesign": "Modificar la personalización",
   "step5.editThreads": "Modificar los hilos",
   "co.item": "Artículo",
   "size.legend": "Tamaño del bordado — {item}",
   "size.auto": "Déjalo en nuestras manos",
   "size.custom": "Indico yo el tamaño",
   "size.helpAuto": "Elegimos el tamaño para el mejor resultado, según la ubicación y tu motivo.",
   "size.hintCustom": "Indica el ancho y el alto del bordado terminado, en cm ({min} a {max}). Comprobamos la viabilidad y nos ponemos en contacto contigo si hace falta algún ajuste.",
   "size.w": "Ancho (cm)",
   "size.h": "Alto (cm)",
   "size.sum": "Bordado de unos {size}. Comprobamos la viabilidad y nos ponemos en contacto contigo si hace falta algún ajuste.",
   "size.ratio": "Se conservan las proporciones de tu imagen: la otra dimensión se calcula sola.",
   "size.errBoth": "Indica el ancho y el alto (en cm), o elige «Déjalo en nuestras manos».",
   "size.errRange": "Las dimensiones deben estar comprendidas entre {min} y {max} cm.",
   "size.fmt": "{w} × {h} cm",
   "size.fmtLong": "{w} × {h} cm (ancho × alto)",
   "size.autoShort": "Déjalo en nuestras manos",
   "size.autoLong": "Déjalo en nuestras manos — el taller elige el tamaño",
   "co.size": "Tamaño del bordado",
   "step5.sizeL": "Tamaño del bordado"
  };
  D.de = {
   "common.back": "Zurück",
   "common.next": "Weiter",
   "common.close": "Schließen",
   "common.loading": "Wird geladen…",
   "common.remove": "Entfernen",
   "common.retry": "Erneut versuchen",
   "common.optional": "optional",
   "common.restart": "Neu beginnen",
   "progress.label": "Schritte deiner Anfrage",
   "progress.step": "Schritt {n} von {total}",
   "step.1": "Artikel",
   "step.2": "Größe und Farbe",
   "step.3": "Personalisierung",
   "step.4": "Garne",
   "step.5": "Zusammenfassung",
   "step1.title": "Wähle deinen Artikel.",
   "step1.sub": "Wähle ein oder mehrere Stücke. Es werden nur verfügbare Artikel angezeigt, zum Preis des Shops: Die Stickerei ist inbegriffen, ohne Aufpreis.",
   "step1.categories": "Kategorien",
   "step1.all": "Alle",
   "step1.search": "Artikel suchen",
   "step1.from": "Ab {price}",
   "step1.add": "Auswählen",
   "step1.added": "Ausgewählt",
   "step1.none": "Kein Artikel entspricht deiner Suche.",
   "step1.selected": "{n} Artikel ausgewählt||{n} Artikel ausgewählt",
   "step1.empty": "Wähle mindestens einen Artikel, um fortzufahren.",
   "step1.catalogError": "Die Artikel konnten momentan nicht geladen werden.",
   "step1.addError": "Dieser Artikel konnte nicht hinzugefügt werden. Versuche es gleich noch einmal.",
   "cat.sweat": "Sweatshirts",
   "cat.tshirt": "T-Shirts",
   "cat.polo": "Poloshirts",
   "cat.headwear": "Caps und Mützen",
   "cat.bag": "Taschen",
   "cat.baby": "Baby",
   "cat.other": "Sonstiges",
   "step2.title": "Wähle deine Größe und deine Farbe.",
   "step2.sub": "Gib für jeden Artikel Größe, Farbe und Menge an. Die angezeigten Preise sind die Preise des Shops.",
   "opt.color": "Farbe",
   "opt.size": "Größe",
   "opt.qty": "Menge",
   "opt.single": "Einzelmodell: Hier gibt es nichts auszuwählen.",
   "step2.chooseColor": "Wähle eine Farbe",
   "step2.chooseSize": "Wähle eine Größe",
   "step2.unavailable": "Diese Kombination ist nicht verfügbar.",
   "step2.incomplete": "Wähle Größe und Farbe jedes Artikels, um fortzufahren.",
   "step2.incompleteShort": "Noch zu ergänzen",
   "step2.removeItem": "Diesen Artikel entfernen",
   "step2.addLine": "Weitere Größe oder Farbe hinzufügen",
   "price.unit": "Stückpreis",
   "price.subtotal": "Zwischensumme Artikel",
   "price.discount": "Rabatt",
   "price.shipping": "Versand (geschätzt)",
   "price.total": "Geschätzte Gesamtsumme",
   "price.calc": "wird berechnet…",
   "price.toConfirm": "noch zu bestätigen",
   "price.free": "Kostenlos",
   "price.freeShipping": "Kostenloser Versand weltweit",
   "price.remaining": "Nur noch {amount} bis zum kostenlosen Versand weltweit",
   "price.thresholdOther": "Kostenloser Versand weltweit ab {amount} Einkaufswert, gemäß den Bedingungen des Shops.",
   "price.note": "Schätzung: Preis des Shops, Stickerei inbegriffen, ohne Aufpreis und ohne Pack-Rabatt. Endpreis und Versand werden bei der Zahlung bestätigt.",
   "price.unavailable": "Die Versandschätzung ist vorübergehend nicht verfügbar.",
   "summary.title": "Meine Anfrage",
   "summary.empty": "Noch kein Artikel ausgewählt.",
   "summary.count": "{n} Stück||{n} Stücke",
   "sum.design": "Personalisierung",
   "sum.text": "Text",
   "sum.image": "Bild",
   "sum.threads": "Garne",
   "sum.none": "Noch festzulegen",
   "restore.notice": "Wir haben deine laufende Anfrage wiederhergestellt.",
   "preselect.notice": "Artikel von der Produktseite hinzugefügt.",
   "preselect.unavailable": "Dieser Artikel steht für die Personalisierung nicht zur Verfügung.",
   "step3.title": "Füge deinen Text oder dein Bild hinzu.",
   "step3.sub": "Wähle nur eine Option: Text oder Bild. Die Vorschau ist unverbindlich.",
   "step3.typeLabel": "Art der Personalisierung",
   "step3.tabText": "Text",
   "step3.tabImage": "Bild",
   "step3.typeTextHelp": "Ein Vorname, ein Wort, ein Datum…",
   "step3.typeImageHelp": "Ein Logo oder eine Zeichnung (PNG oder JPG)",
   "step3.textLabel": "Dein Text",
   "step3.textHelp": "Maximal {max} Zeichen. Buchstaben, Zahlen und einfache Satzzeichen.",
   "step3.counter": "{n}/{max}",
   "step3.textPlaceholder": "z. B. Yanis",
   "step3.fontLabel": "Stickschrift",
   "step3.unsupported": "Einige Zeichen werden nicht unterstützt (Emojis, Symbole) und wurden entfernt.",
   "step3.imageLabel": "Dein Bild",
   "step3.drop": "Ziehe dein Bild hierher",
   "step3.or": "oder",
   "step3.pick": "Datei auswählen",
   "step3.imageRules": "PNG oder JPG · maximal {max} MB · mindestens {min} px an der längsten Seite",
   "step3.imageTips": "Am besten eignen sich ein klares, einfaches Logo oder eine Zeichnung mit wenigen Farben. Fotos, Farbverläufe und sehr detailreiche Bilder lassen sich schwer sticken: Das PTB-Team sagt dir, ob dein Motiv umsetzbar ist.",
   "step3.imageNotProd": "Deine Datei dient als Vorlage: Sie wird nicht unverändert für die Produktion verwendet, das Team passt sie für die Stickerei an.",
   "step3.replace": "Ersetzen",
   "step3.delete": "Löschen",
   "step3.fileInfo": "{name} · {w}×{h} px · {size}",
   "step3.imageBusy": "Bild wird gelesen…",
   "step3.previewTitle": "Unverbindliche Vorschau",
   "step3.previewNote": "Unverbindliche Vorschau: Das gestickte Ergebnis kann leicht abweichen (Größe, Feinheit der Details, Garnfarbe).",
   "step3.emptyPreview": "Dein Text",
   "step3.placementTitle": "Position der Stickerei",
   "step3.placementFor": "Position auf {item}",
   "step3.sideNote": "Links und rechts: aus Sicht der Person, die den Artikel trägt.",
   "step3.sameDesign": "Dasselbe Motiv wird auf jeden Artikel deiner Anfrage gestickt. Du kannst für jede Artikelart eine andere Position wählen.",
   "step3.instrLabel": "Zusätzliche Hinweise",
   "step3.instrHelp": "Anpassungen, Hinweise zur Position, Details, die beachtet werden sollen…",
   "step3.needType": "Wähle einen Text oder ein Bild, um fortzufahren.",
   "step3.needText": "Gib deinen Text ein, um fortzufahren.",
   "step3.needImage": "Füge ein gültiges Bild hinzu, um fortzufahren.",
   "step3.needPlacement": "Wähle für jeden Artikel eine Position.",
   "pl.chest_left": "Brust links",
   "pl.chest_right": "Brust rechts",
   "pl.chest_center": "Brust Mitte",
   "pl.back": "Rücken",
   "pl.sleeve_left": "Ärmel links",
   "pl.sleeve_right": "Ärmel rechts",
   "pl.front": "Vorderseite",
   "pl.side_left": "Seite links",
   "pl.side_right": "Seite rechts",
   "pl.back_cap": "Hinten",
   "pl.custom": "Andere (bitte angeben)",
   "err.imgType": "Format wird nicht unterstützt. Verwende eine PNG- oder JPG-Datei.",
   "err.imgSvg": "SVG-Dateien werden aus Sicherheitsgründen nicht akzeptiert. Exportiere deine Zeichnung als PNG.",
   "err.imgSize": "Datei zu groß ({size}). Maximal: {max}.",
   "err.imgSmall": "Bild zu klein ({w}×{h} px). Mindestens: {min} px an der längsten Seite.",
   "err.imgLarge": "Bildabmessungen zu groß (maximal {max} px).",
   "err.imgCorrupt": "Diese Datei kann nicht gelesen werden. Prüfe, ob es sich um ein unbeschädigtes PNG- oder JPG-Bild handelt.",
   "err.imgMismatch": "Der Inhalt der Datei passt nicht zu ihrem Format.",
   "step4.title": "Wähle die Farben deiner Stickerei.",
   "step4.sub": "Wähle 1 bis {max} Garnfarben. Die am Bildschirm angezeigten Farben sind nur Richtwerte.",
   "step4.palette": "Garnpalette",
   "step4.count": "{n}/{max} Farbe gewählt||{n}/{max} Farben gewählt",
   "step4.selected": "Deine Garnfarben",
   "step4.none": "Noch keine Farbe gewählt.",
   "step4.max": "Maximum erreicht: {max} Farben. Entferne eine Farbe, um eine andere zu wählen.",
   "step4.need": "Wähle mindestens eine Garnfarbe, um fortzufahren.",
   "step4.noteText": "Die erste Farbe ist die der Buchstaben. Die zweite, falls du eine wählst, dient in der Vorschau als Umrandung.",
   "step4.noteImage": "Bei einem mehrfarbigen Bild bestätigt das PTB-Team das Endergebnis und die Anzahl der Garnfarben.",
   "step4.indicative": "Die Farbtöne am Bildschirm sind Richtwerte: Die echten Garne können leicht abweichen.",
   "step4.code": "Ref. {code}",
   "step4.removeOne": "{name} entfernen",
   "step5.title": "Prüfe und sende deine Anfrage.",
   "step5.sub": "Lies dein Projekt noch einmal durch. Sobald deine Anfrage gesendet ist, bestätigst du sie über die sichere Shopify-Zahlung: Unser Team bearbeitet sie nach dieser Bestätigung.",
   "step5.subReq": "Lies dein Projekt noch einmal durch. Es handelt sich um eine Personalisierungsanfrage: Jetzt wird keine Zahlung verlangt.",
   "step5.afterSend": "Nach dem Absenden gehst du zur sicheren Shopify-Zahlung, um deine Anfrage zu bestätigen. Es gelten die Preise des Shops, ohne Stickerei-Aufpreis und ohne Pack-Rabatt.",
   "step5.markerNote": "Bei der Zahlung siehst du eine Zeile „Atelier PTB — Individuelle Stickerei (ohne Aufpreis)“ über 0 €: Sie dient der Nachverfolgung deiner Anfrage und erhöht den Preis deiner Artikel nicht.",
   "step5.preparing": "Zahlung wird vorbereitet…",
   "step5.sendShort": "Senden",
   "step5.items": "Dein Artikel und seine Personalisierung",
   "step5.design": "Deine Personalisierung",
   "step5.designText": "Text: „{text}“",
   "step5.designImage": "Bild: {name}",
   "step5.fontL": "Schrift",
   "step5.threadsL": "Stickgarne",
   "step5.placementL": "Position",
   "step5.instrL": "Hinweise",
   "step5.edit": "Bearbeiten",
   "step5.contact": "Deine Kontaktdaten",
   "f.first": "Vorname",
   "f.last": "Nachname",
   "f.email": "E-Mail",
   "f.phone": "Telefon (optional)",
   "f.message": "Nachricht an das Team (optional)",
   "f.messageHelp": "Ein Hinweis, ein Wunschtermin, eine Frage…",
   "step5.shipTo": "Geschätzter Versand nach: {country}. Du kannst das Land im Menü der Seite ändern.",
   "step5.consent": "Ich bestätige, dass diese Angaben korrekt sind und dass ich berechtigt bin, den angegebenen Text oder das Bild zu verwenden. Ich verstehe, dass meine Anfrage über die sichere Shopify-Zahlung bestätigt wird.",
   "step5.consentReq": "Ich bestätige, dass diese Angaben korrekt sind und dass ich berechtigt bin, den angegebenen Text oder das Bild zu verwenden. Ich verstehe, dass es sich um eine Anfrage und nicht um eine Bestellung handelt: Jetzt wird keine Zahlung verlangt.",
   "step5.privacy": "Deine Kontaktdaten, dein Projekt und deine Datei dienen ausschließlich der Bearbeitung deiner Anfrage. Die Datei wird in einem privaten Bereich aufbewahrt, auf den nur das PTB-Team Zugriff hat,",
   "step5.privacyText": "Deine Kontaktdaten und dein Projekt dienen ausschließlich der Bearbeitung deiner Anfrage.",
   "step5.retention": "und nach {n} Monat gelöscht.||und nach {n} Monaten gelöscht.",
   "step5.privacyLink": "Datenschutzerklärung",
   "step5.send": "Meine Anfrage senden",
   "step5.sending": "Wird gesendet…",
   "step5.previewMode": "Vorschaumodus: Das Senden ist deaktiviert, bis der Dienst zum Empfang der Anfragen eingerichtet ist. Es wird nichts gesendet.",
   "step5.disabled": "Das Senden von Anfragen ist noch nicht verfügbar. Es wurde keine Anfrage gesendet.",
   "err.first": "Gib deinen Vornamen an.",
   "err.last": "Gib deinen Nachnamen an.",
   "err.email": "Gib eine gültige E-Mail-Adresse an.",
   "err.phone": "Diese Telefonnummer scheint nicht gültig zu sein.",
   "err.consent": "Setze das Häkchen bei der Bestätigung, um deine Anfrage zu senden.",
   "err.stepsIncomplete": "Ein vorheriger Schritt ist unvollständig: {step}.",
   "err.send.network": "Verbindung nicht möglich. Prüfe deine Verbindung: Deine Angaben bleiben erhalten, du kannst es erneut versuchen.",
   "err.send.server": "Das Senden war nicht erfolgreich. Deine Angaben bleiben erhalten, du kannst es gleich noch einmal versuchen.",
   "err.send.rate": "Zu viele Anfragen in kurzer Zeit. Versuche es in einigen Minuten erneut.",
   "err.send.invalid": "Die Anfrage konnte nicht angenommen werden: {msg}",
   "err.send.spam": "Die Anfrage wurde von der Spam-Prüfung abgelehnt. Lade die Seite neu und versuche es erneut.",
   "err.send.cart": "Die Zahlung konnte nicht vorbereitet werden ({msg}). Prüfe deine Artikel und versuche es erneut: Es wurde nichts gesendet.",
   "err.send.contact": "Wenn das Problem weiterhin besteht, schreib uns über die Kontaktseite.",
   "err.send.contactLink": "Kontaktseite",
   "ok.title": "Danke für deine Personalisierungsanfrage!",
   "ok.body": "Wir haben dein Projekt erhalten. Unser Team prüft die Details deiner Stickerei und meldet sich per E-Mail bei dir.",
   "ok.ref": "Referenz deiner Anfrage",
   "ok.mailSent": "Eine Bestätigungs-E-Mail wurde soeben an {email} gesendet. Denk daran, auch deinen Spam-Ordner zu prüfen.",
   "ok.mailSentPay": "Eine Bestätigungs-E-Mail mit dem Link zur Bestätigung deiner Anfrage wurde soeben an {email} gesendet.",
   "ok.last": "Letzter Schritt: Bestätige deine Anfrage",
   "ok.lastText": "Damit wir sie bearbeiten können, schließe deine Bestellung über die sichere Shopify-Zahlung ab. Preise des Shops, ohne Stickerei-Aufpreis und ohne Pack-Rabatt.",
   "ok.pay": "Meine Anfrage bestätigen",
   "ok.redirect": "Weiterleitung zur sicheren Zahlung…",
   "ok.mailFailed": "Deine Anfrage ist gespeichert, aber die Bestätigungs-E-Mail konnte nicht gesendet werden. Bewahre diese Referenz gut auf.",
   "ok.next": "Und wie geht es weiter?",
   "ok.n1": "Du bestätigst deine Anfrage über die sichere Shopify-Zahlung.",
   "ok.n2": "Unser Team prüft die Details deiner Stickerei: Machbarkeit, Größe, Garnfarben.",
   "ok.n3": "Falls etwas geklärt werden muss, meldet sich das Team per E-Mail bei dir.",
   "ok.q1": "Das Team prüft dein Projekt: Machbarkeit, Größe der Stickerei, Garnfarben.",
   "ok.q2": "Du erhältst eine Antwort per E-Mail, gegebenenfalls mit Rückfragen.",
   "ok.q3": "Vor deiner Bestätigung wird nichts bestellt oder bezahlt.",
   "co.custom": "Personalisierung",
   "co.font": "Schrift",
   "co.threads": "Garne",
   "co.place": "Position",
   "co.instr": "Hinweise",
   "co.ref": "Anfrage",
   "ok.new": "Weitere Anfrage stellen",
   "ok.shop": "Zurück zum Shop",
   "step2.perArticle": "Jede Zeile ist ein Artikel mit eigener Personalisierung im nächsten Schritt. Um zwei verschiedene Motive zu sticken, füge zwei Zeilen hinzu („Weitere Größe oder Farbe hinzufügen“).",
   "line.n": "Artikel {n}",
   "step3.subMulti": "Wähle für jeden Artikel eine Personalisierung oder dieselbe für alle. Die Vorschau ist unverbindlich.",
   "mode.label": "Umfang der Personalisierung",
   "mode.same": "Dieselbe Personalisierung für alle",
   "mode.sameHelp": "Dasselbe Motiv auf allen {n} Artikeln.",
   "mode.each": "Eine Personalisierung pro Artikel",
   "mode.eachHelp": "Text oder Bild, Garne und Position individuell für jeden Artikel.",
   "mode.confirmTitle": "Bestätigen",
   "mode.confirm": "Die individuellen Personalisierungen der einzelnen Artikel werden durch die von Artikel 1 ersetzt. Fortfahren?",
   "mode.confirmYes": "Ja, auf alle anwenden",
   "common.cancel": "Abbrechen",
   "tabs.label": "Artikel deiner Anfrage",
   "copy.label": "Personalisierung eines anderen Artikels kopieren",
   "copy.labelThreads": "Garne eines anderen Artikels kopieren",
   "copy.choose": "Artikel auswählen…",
   "step3.scopeSame": "Diese Personalisierung wird auf jeden der {n} Artikel deiner Anfrage gestickt (die Position lässt sich pro Artikel einstellen).",
   "step3.scopeEach": "Du personalisierst: {n}.",
   "step3.qtyNote": "Menge: {n} — dieselbe Stickerei wird auf jedes Stück gestickt.",
   "step3.oneDesign": "Wähle die Position der Stickerei.",
   "step5.itemsMany": "Deine Artikel und ihre Personalisierung",
   "step5.editDesign": "Personalisierung bearbeiten",
   "step5.editThreads": "Garne bearbeiten",
   "co.item": "Artikel",
   "size.legend": "Größe der Stickerei — {item}",
   "size.auto": "Überlass es uns",
   "size.custom": "Ich gebe die Größe an",
   "size.helpAuto": "Wir wählen die Größe für das beste Ergebnis, je nach Position und Motiv.",
   "size.hintCustom": "Gib Breite und Höhe der fertigen Stickerei in cm an ({min} bis {max}). Wir prüfen die Machbarkeit und melden uns bei dir, falls eine Anpassung nötig ist.",
   "size.w": "Breite (cm)",
   "size.h": "Höhe (cm)",
   "size.sum": "Stickerei von etwa {size}. Wir prüfen die Machbarkeit und melden uns bei dir, falls eine Anpassung nötig ist.",
   "size.ratio": "Die Proportionen deines Bildes bleiben erhalten: Die andere Abmessung wird automatisch berechnet.",
   "size.errBoth": "Gib Breite und Höhe (in cm) an oder wähle „Überlass es uns“.",
   "size.errRange": "Die Abmessungen müssen zwischen {min} und {max} cm liegen.",
   "size.fmt": "{w} × {h} cm",
   "size.fmtLong": "{w} × {h} cm (Breite × Höhe)",
   "size.autoShort": "Überlass es uns",
   "size.autoLong": "Überlass es uns — das Atelier wählt die Größe",
   "co.size": "Größe der Stickerei",
   "step5.sizeL": "Größe der Stickerei"
  };
  D.it = {
   "common.back": "Indietro",
   "common.next": "Continua",
   "common.close": "Chiudi",
   "common.loading": "Caricamento…",
   "common.remove": "Rimuovi",
   "common.retry": "Riprova",
   "common.optional": "facoltativo",
   "common.restart": "Ricomincia",
   "progress.label": "Passaggi della tua richiesta",
   "progress.step": "Passaggio {n} di {total}",
   "step.1": "Articolo",
   "step.2": "Taglia e colore",
   "step.3": "Personalizzazione",
   "step.4": "Fili",
   "step.5": "Riepilogo",
   "step1.title": "Scegli il tuo articolo.",
   "step1.sub": "Seleziona uno o più capi. Vengono proposti solo gli articoli disponibili, al prezzo del negozio: il ricamo è incluso, senza supplemento.",
   "step1.categories": "Categorie",
   "step1.all": "Tutto",
   "step1.search": "Cerca un articolo",
   "step1.from": "Da {price}",
   "step1.add": "Scegli",
   "step1.added": "Scelto",
   "step1.none": "Nessun articolo corrisponde alla tua ricerca.",
   "step1.selected": "{n} articolo selezionato||{n} articoli selezionati",
   "step1.empty": "Scegli almeno un articolo per continuare.",
   "step1.catalogError": "Al momento non è possibile caricare gli articoli.",
   "step1.addError": "Non è stato possibile aggiungere questo articolo. Riprova tra un attimo.",
   "cat.sweat": "Felpe",
   "cat.tshirt": "T-shirt",
   "cat.polo": "Polo",
   "cat.headwear": "Cappellini e berretti",
   "cat.bag": "Borse",
   "cat.baby": "Neonato",
   "cat.other": "Altro",
   "step2.title": "Seleziona la tua taglia e il tuo colore.",
   "step2.sub": "Per ogni articolo, indica la taglia, il colore e la quantità. I prezzi mostrati sono quelli del negozio.",
   "opt.color": "Colore",
   "opt.size": "Taglia",
   "opt.qty": "Quantità",
   "opt.single": "Modello unico: qui non c'è nulla da scegliere.",
   "step2.chooseColor": "Scegli un colore",
   "step2.chooseSize": "Scegli una taglia",
   "step2.unavailable": "Questa combinazione non è disponibile.",
   "step2.incomplete": "Scegli la taglia e il colore di ogni articolo per continuare.",
   "step2.incompleteShort": "Da completare",
   "step2.removeItem": "Rimuovi questo articolo",
   "step2.addLine": "Aggiungi un'altra taglia o colore",
   "price.unit": "Prezzo unitario",
   "price.subtotal": "Subtotale articoli",
   "price.discount": "Sconto",
   "price.shipping": "Spedizione (stimata)",
   "price.total": "Totale stimato",
   "price.calc": "calcolo in corso…",
   "price.toConfirm": "da confermare",
   "price.free": "Gratuita",
   "price.freeShipping": "Spedizione gratuita in tutto il mondo",
   "price.remaining": "Mancano solo {amount} per ottenere la spedizione gratuita in tutto il mondo",
   "price.thresholdOther": "Spedizione gratuita in tutto il mondo a partire da {amount} di acquisti, secondo le condizioni del negozio.",
   "price.note": "Stima: prezzo del negozio, ricamo incluso, senza supplemento né sconto pack. Il prezzo finale e la spedizione vengono confermati al pagamento.",
   "price.unavailable": "La stima della spedizione è momentaneamente non disponibile.",
   "summary.title": "La mia richiesta",
   "summary.empty": "Nessun articolo scelto per il momento.",
   "summary.count": "{n} capo||{n} capi",
   "sum.design": "Personalizzazione",
   "sum.text": "Testo",
   "sum.image": "Immagine",
   "sum.threads": "Fili",
   "sum.none": "Da definire",
   "restore.notice": "Abbiamo ritrovato la tua richiesta in corso.",
   "preselect.notice": "Articolo aggiunto dalla scheda prodotto.",
   "preselect.unavailable": "Questo articolo non è disponibile per la personalizzazione.",
   "step3.title": "Aggiungi il tuo testo o la tua immagine.",
   "step3.sub": "Scegli una sola opzione: testo o immagine. L'anteprima è indicativa.",
   "step3.typeLabel": "Tipo di personalizzazione",
   "step3.tabText": "Testo",
   "step3.tabImage": "Immagine",
   "step3.typeTextHelp": "Un nome, una parola, una data…",
   "step3.typeImageHelp": "Un logo o un disegno (PNG o JPG)",
   "step3.textLabel": "Il tuo testo",
   "step3.textHelp": "{max} caratteri al massimo. Lettere, numeri e punteggiatura semplice.",
   "step3.counter": "{n}/{max}",
   "step3.textPlaceholder": "Es.: Yanis",
   "step3.fontLabel": "Carattere del ricamo",
   "step3.unsupported": "Alcuni caratteri non sono supportati (emoji, simboli) e sono stati rimossi.",
   "step3.imageLabel": "La tua immagine",
   "step3.drop": "Trascina qui la tua immagine",
   "step3.or": "oppure",
   "step3.pick": "Scegli un file",
   "step3.imageRules": "PNG o JPG · {max} MB al massimo · almeno {min} px sul lato più lungo",
   "step3.imageTips": "Preferisci un logo o un disegno nitido, semplice e con pochi colori. Foto, sfumature e immagini molto dettagliate sono difficili da ricamare: il team PTB ti dirà se il tuo motivo è realizzabile.",
   "step3.imageNotProd": "Il tuo file serve da riferimento: non viene usato così com'è per la produzione, il team lo adatta al ricamo.",
   "step3.replace": "Sostituisci",
   "step3.delete": "Elimina",
   "step3.fileInfo": "{name} · {w}×{h} px · {size}",
   "step3.imageBusy": "Lettura dell'immagine…",
   "step3.previewTitle": "Anteprima indicativa",
   "step3.previewNote": "Anteprima indicativa: il risultato ricamato può differire leggermente (dimensioni, finezza dei dettagli, colore dei fili).",
   "step3.emptyPreview": "Il tuo testo",
   "step3.placementTitle": "Posizione del ricamo",
   "step3.placementFor": "Posizione su {item}",
   "step3.sideNote": "Sinistra e destra: dal punto di vista di chi indossa il capo.",
   "step3.sameDesign": "Lo stesso motivo viene ricamato su ogni articolo della tua richiesta. Puoi scegliere una posizione diversa per ogni tipo di articolo.",
   "step3.instrLabel": "Istruzioni aggiuntive",
   "step3.instrHelp": "Ritocchi, precisazioni sulla posizione, dettagli da rispettare…",
   "step3.needType": "Scegli un testo o un'immagine per continuare.",
   "step3.needText": "Inserisci il tuo testo per continuare.",
   "step3.needImage": "Aggiungi un'immagine valida per continuare.",
   "step3.needPlacement": "Scegli una posizione per ogni articolo.",
   "pl.chest_left": "Petto sinistro",
   "pl.chest_right": "Petto destro",
   "pl.chest_center": "Petto centro",
   "pl.back": "Schiena",
   "pl.sleeve_left": "Manica sinistra",
   "pl.sleeve_right": "Manica destra",
   "pl.front": "Parte anteriore",
   "pl.side_left": "Lato sinistro",
   "pl.side_right": "Lato destro",
   "pl.back_cap": "Retro",
   "pl.custom": "Altra (da specificare)",
   "err.imgType": "Formato non supportato. Usa un file PNG o JPG.",
   "err.imgSvg": "I file SVG non sono accettati per motivi di sicurezza. Esporta il tuo disegno in PNG.",
   "err.imgSize": "File troppo pesante ({size}). Massimo: {max}.",
   "err.imgSmall": "Immagine troppo piccola ({w}×{h} px). Minimo: {min} px sul lato più lungo.",
   "err.imgLarge": "Immagine troppo grande nelle dimensioni (massimo {max} px).",
   "err.imgCorrupt": "Impossibile leggere questo file. Verifica che si tratti di un'immagine PNG o JPG integra.",
   "err.imgMismatch": "Il contenuto del file non corrisponde al suo formato.",
   "step4.title": "Scegli i colori del tuo ricamo.",
   "step4.sub": "Seleziona da 1 a {max} colori di filo. I colori mostrati sullo schermo sono indicativi.",
   "step4.palette": "Palette di fili",
   "step4.count": "{n}/{max} colore scelto||{n}/{max} colori scelti",
   "step4.selected": "I tuoi colori di filo",
   "step4.none": "Nessun colore scelto per il momento.",
   "step4.max": "Massimo raggiunto: {max} colori. Rimuovi un colore per sceglierne un altro.",
   "step4.need": "Scegli almeno un colore di filo per continuare.",
   "step4.noteText": "Il primo colore è quello delle lettere. Il secondo, se ne scegli uno, serve da contorno nell'anteprima.",
   "step4.noteImage": "Per un'immagine multicolore, il risultato finale e il numero di colori di filo vengono confermati dal team PTB.",
   "step4.indicative": "Le tonalità a schermo sono indicative: i fili reali possono variare leggermente.",
   "step4.code": "Rif. {code}",
   "step4.removeOne": "Rimuovi {name}",
   "step5.title": "Controlla e invia la tua richiesta.",
   "step5.sub": "Rileggi il tuo progetto. Dopo l'invio della richiesta, la convalidi nel pagamento sicuro Shopify: il nostro team la elabora dopo questa convalida.",
   "step5.subReq": "Rileggi il tuo progetto. Si tratta di una richiesta di personalizzazione: ora non viene richiesto alcun pagamento.",
   "step5.afterSend": "Dopo l'invio passi al pagamento sicuro Shopify per convalidare la tua richiesta. I prezzi sono quelli del negozio, senza supplemento per il ricamo e senza sconto pack.",
   "step5.markerNote": "Nel pagamento vedrai una riga «Atelier PTB — Personalizzazione ricamata (senza supplemento)» da 0 €: serve al monitoraggio della tua richiesta e non aggiunge nulla al prezzo dei tuoi articoli.",
   "step5.preparing": "Preparazione del pagamento…",
   "step5.sendShort": "Invia",
   "step5.items": "Il tuo articolo e la sua personalizzazione",
   "step5.design": "La tua personalizzazione",
   "step5.designText": "Testo: «{text}»",
   "step5.designImage": "Immagine: {name}",
   "step5.fontL": "Carattere",
   "step5.threadsL": "Fili da ricamo",
   "step5.placementL": "Posizione",
   "step5.instrL": "Istruzioni",
   "step5.edit": "Modifica",
   "step5.contact": "I tuoi recapiti",
   "f.first": "Nome",
   "f.last": "Cognome",
   "f.email": "E-mail",
   "f.phone": "Telefono (facoltativo)",
   "f.message": "Messaggio per il team (facoltativo)",
   "f.messageHelp": "Una precisazione, una data desiderata, una domanda…",
   "step5.shipTo": "Spedizione stimata per: {country}. Puoi cambiare paese dal menu del sito.",
   "step5.consent": "Confermo che queste informazioni sono esatte e che ho il diritto di utilizzare il testo o l'immagine forniti. Capisco che la mia richiesta verrà convalidata nel pagamento sicuro Shopify.",
   "step5.consentReq": "Confermo che queste informazioni sono esatte e che ho il diritto di utilizzare il testo o l'immagine forniti. Capisco che si tratta di una richiesta e non di un ordine: ora non viene richiesto alcun pagamento.",
   "step5.privacy": "I tuoi recapiti, il tuo progetto e il tuo file servono esclusivamente a elaborare la tua richiesta. Il file viene conservato in uno spazio privato, accessibile solo al team PTB,",
   "step5.privacyText": "I tuoi recapiti e il tuo progetto servono esclusivamente a elaborare la tua richiesta.",
   "step5.retention": "e poi eliminato dopo {n} mese.||e poi eliminato dopo {n} mesi.",
   "step5.privacyLink": "Informativa sulla privacy",
   "step5.send": "Invia la mia richiesta",
   "step5.sending": "Invio in corso…",
   "step5.previewMode": "Modalità anteprima: l'invio è disattivato finché il servizio di ricezione delle richieste non è configurato. Non verrà inviato nulla.",
   "step5.disabled": "L'invio delle richieste non è ancora disponibile. Nessuna richiesta è stata inviata.",
   "err.first": "Indica il tuo nome.",
   "err.last": "Indica il tuo cognome.",
   "err.email": "Indica un indirizzo e-mail valido.",
   "err.phone": "Questo numero di telefono non sembra valido.",
   "err.consent": "Spunta la casella di conferma per inviare la tua richiesta.",
   "err.stepsIncomplete": "Un passaggio precedente è incompleto: {step}.",
   "err.send.network": "Impossibile connettersi. Controlla la connessione: le tue informazioni sono conservate, puoi riprovare.",
   "err.send.server": "L'invio non è andato a buon fine. Le tue informazioni sono conservate, puoi riprovare tra un attimo.",
   "err.send.rate": "Troppe richieste in poco tempo. Riprova tra qualche minuto.",
   "err.send.invalid": "Non è stato possibile accettare la richiesta: {msg}",
   "err.send.spam": "La richiesta è stata rifiutata dal controllo antispam. Ricarica la pagina e riprova.",
   "err.send.cart": "Non è stato possibile preparare il pagamento ({msg}). Controlla i tuoi articoli e riprova: non è stato inviato nulla.",
   "err.send.contact": "Se il problema persiste, scrivici dalla pagina Contatti.",
   "err.send.contactLink": "Pagina Contatti",
   "ok.title": "Grazie per la tua richiesta di personalizzazione!",
   "ok.body": "Abbiamo ricevuto il tuo progetto. Il nostro team esaminerà i dettagli del tuo ricamo e ti ricontatterà via e-mail.",
   "ok.ref": "Riferimento della tua richiesta",
   "ok.mailSent": "Abbiamo appena inviato un'e-mail di conferma a {email}. Ricordati di controllare la cartella dello spam.",
   "ok.mailSentPay": "Abbiamo appena inviato a {email} un'e-mail di conferma con il link per convalidare la tua richiesta.",
   "ok.last": "Ultimo passaggio: convalida la tua richiesta",
   "ok.lastText": "Perché possiamo elaborarla, completa il tuo ordine nel pagamento sicuro Shopify. Prezzi del negozio, senza supplemento per il ricamo né sconto pack.",
   "ok.pay": "Convalida la mia richiesta",
   "ok.redirect": "Reindirizzamento al pagamento sicuro…",
   "ok.mailFailed": "La tua richiesta è registrata, ma non è stato possibile inviare l'e-mail di conferma. Conserva con cura questo riferimento.",
   "ok.next": "E poi?",
   "ok.n1": "Convalidi la tua richiesta nel pagamento sicuro Shopify.",
   "ok.n2": "Il nostro team esamina i dettagli del tuo ricamo: fattibilità, dimensioni, colori di filo.",
   "ok.n3": "Se serve qualche precisazione, il team ti ricontatta via e-mail.",
   "ok.q1": "Il team esamina il tuo progetto: fattibilità, dimensioni del ricamo, colori di filo.",
   "ok.q2": "Ricevi una risposta via e-mail, con le eventuali precisazioni.",
   "ok.q3": "Nulla viene ordinato né pagato prima della tua conferma.",
   "co.custom": "Personalizzazione",
   "co.font": "Carattere",
   "co.threads": "Fili",
   "co.place": "Posizione",
   "co.instr": "Istruzioni",
   "co.ref": "Richiesta",
   "ok.new": "Fare un'altra richiesta",
   "ok.shop": "Torna al negozio",
   "step2.perArticle": "Ogni riga è un articolo con la sua personalizzazione nel passaggio successivo. Per ricamare due motivi diversi, aggiungi due righe («Aggiungi un'altra taglia o colore»).",
   "line.n": "Articolo {n}",
   "step3.subMulti": "Scegli una personalizzazione per ogni articolo, oppure la stessa per tutti. L'anteprima è indicativa.",
   "mode.label": "Ambito della personalizzazione",
   "mode.same": "La stessa personalizzazione per tutti",
   "mode.sameHelp": "Lo stesso motivo su tutti i {n} articoli.",
   "mode.each": "Una personalizzazione per articolo",
   "mode.eachHelp": "Testo o immagine, fili e posizione propri di ogni articolo.",
   "mode.confirmTitle": "Conferma",
   "mode.confirm": "Le personalizzazioni proprie di ogni articolo verranno sostituite da quella dell'articolo 1. Continuare?",
   "mode.confirmYes": "Sì, applica a tutti",
   "common.cancel": "Annulla",
   "tabs.label": "Articoli della tua richiesta",
   "copy.label": "Copia la personalizzazione di un altro articolo",
   "copy.labelThreads": "Copia i fili di un altro articolo",
   "copy.choose": "Scegli un articolo…",
   "step3.scopeSame": "Questa personalizzazione verrà ricamata su ciascuno dei {n} articoli della tua richiesta (la posizione resta regolabile per articolo).",
   "step3.scopeEach": "Stai personalizzando: {n}.",
   "step3.qtyNote": "Quantità: {n} — lo stesso ricamo viene realizzato su ogni capo.",
   "step3.oneDesign": "Scegli la posizione del ricamo.",
   "step5.itemsMany": "I tuoi articoli e la loro personalizzazione",
   "step5.editDesign": "Modifica la personalizzazione",
   "step5.editThreads": "Modifica i fili",
   "co.item": "Articolo",
   "size.legend": "Dimensioni del ricamo — {item}",
   "size.auto": "Lascia fare a noi",
   "size.custom": "Indico io le dimensioni",
   "size.helpAuto": "Scegliamo noi le dimensioni per il miglior risultato, in base alla posizione e al tuo motivo.",
   "size.hintCustom": "Indica la larghezza e l'altezza del ricamo finito, in cm (da {min} a {max}). Verifichiamo la fattibilità e ti contattiamo se serve un adattamento.",
   "size.w": "Larghezza (cm)",
   "size.h": "Altezza (cm)",
   "size.sum": "Ricamo di circa {size}. Verifichiamo la fattibilità e ti contattiamo se serve un adattamento.",
   "size.ratio": "Le proporzioni della tua immagine vengono mantenute: l'altra dimensione si calcola da sola.",
   "size.errBoth": "Indica la larghezza e l'altezza (in cm), oppure scegli «Lascia fare a noi».",
   "size.errRange": "Le dimensioni devono essere comprese tra {min} e {max} cm.",
   "size.fmt": "{w} × {h} cm",
   "size.fmtLong": "{w} × {h} cm (larghezza × altezza)",
   "size.autoShort": "Lascia fare a noi",
   "size.autoLong": "Lascia fare a noi — il laboratorio sceglie le dimensioni",
   "co.size": "Dimensioni del ricamo",
   "step5.sizeL": "Dimensioni del ricamo"
  };
  D.nl = {
   "common.back": "Terug",
   "common.next": "Doorgaan",
   "common.close": "Sluiten",
   "common.loading": "Laden…",
   "common.remove": "Verwijderen",
   "common.retry": "Opnieuw proberen",
   "common.optional": "optioneel",
   "common.restart": "Opnieuw beginnen",
   "progress.label": "Stappen van je aanvraag",
   "progress.step": "Stap {n} van {total}",
   "step.1": "Artikel",
   "step.2": "Maat en kleur",
   "step.3": "Personalisatie",
   "step.4": "Garens",
   "step.5": "Overzicht",
   "step1.title": "Kies je artikel.",
   "step1.sub": "Kies één of meer stukken. Alleen beschikbare artikelen worden getoond, tegen de prijs van de winkel: het borduurwerk is inbegrepen, zonder toeslag.",
   "step1.categories": "Categorieën",
   "step1.all": "Alles",
   "step1.search": "Zoek een artikel",
   "step1.from": "Vanaf {price}",
   "step1.add": "Kiezen",
   "step1.added": "Gekozen",
   "step1.none": "Geen artikel komt overeen met je zoekopdracht.",
   "step1.selected": "{n} artikel geselecteerd||{n} artikelen geselecteerd",
   "step1.empty": "Kies minstens één artikel om door te gaan.",
   "step1.catalogError": "De artikelen konden momenteel niet worden geladen.",
   "step1.addError": "Dit artikel kon niet worden toegevoegd. Probeer het zo meteen opnieuw.",
   "cat.sweat": "Sweaters",
   "cat.tshirt": "T-shirts",
   "cat.polo": "Polo's",
   "cat.headwear": "Petten en mutsen",
   "cat.bag": "Tassen",
   "cat.baby": "Baby",
   "cat.other": "Overig",
   "step2.title": "Kies je maat en je kleur.",
   "step2.sub": "Geef voor elk artikel de maat, de kleur en de hoeveelheid aan. De getoonde prijzen zijn die van de winkel.",
   "opt.color": "Kleur",
   "opt.size": "Maat",
   "opt.qty": "Aantal",
   "opt.single": "Enkel model: hier valt niets te kiezen.",
   "step2.chooseColor": "Kies een kleur",
   "step2.chooseSize": "Kies een maat",
   "step2.unavailable": "Deze combinatie is niet beschikbaar.",
   "step2.incomplete": "Kies de maat en de kleur van elk artikel om door te gaan.",
   "step2.incompleteShort": "Nog aan te vullen",
   "step2.removeItem": "Dit artikel verwijderen",
   "step2.addLine": "Nog een maat of kleur toevoegen",
   "price.unit": "Stukprijs",
   "price.subtotal": "Subtotaal artikelen",
   "price.discount": "Korting",
   "price.shipping": "Verzending (geschat)",
   "price.total": "Geschat totaal",
   "price.calc": "berekenen…",
   "price.toConfirm": "te bevestigen",
   "price.free": "Gratis",
   "price.freeShipping": "Gratis wereldwijde verzending",
   "price.remaining": "Nog maar {amount} te gaan voor gratis wereldwijde verzending",
   "price.thresholdOther": "Gratis wereldwijde verzending vanaf {amount} aan aankopen, volgens de voorwaarden van de winkel.",
   "price.note": "Schatting: prijs van de winkel, borduurwerk inbegrepen, zonder toeslag en zonder packkorting. De eindprijs en de verzending worden bij de betaling bevestigd.",
   "price.unavailable": "De verzendschatting is tijdelijk niet beschikbaar.",
   "summary.title": "Mijn aanvraag",
   "summary.empty": "Nog geen artikel gekozen.",
   "summary.count": "{n} stuk||{n} stuks",
   "sum.design": "Personalisatie",
   "sum.text": "Tekst",
   "sum.image": "Afbeelding",
   "sum.threads": "Garens",
   "sum.none": "Nog te bepalen",
   "restore.notice": "We hebben je lopende aanvraag teruggevonden.",
   "preselect.notice": "Artikel toegevoegd vanaf de productpagina.",
   "preselect.unavailable": "Dit artikel is niet beschikbaar voor personalisatie.",
   "step3.title": "Voeg je tekst of afbeelding toe.",
   "step3.sub": "Kies één optie: tekst of afbeelding. De voorvertoning is indicatief.",
   "step3.typeLabel": "Soort personalisatie",
   "step3.tabText": "Tekst",
   "step3.tabImage": "Afbeelding",
   "step3.typeTextHelp": "Een voornaam, een woord, een datum…",
   "step3.typeImageHelp": "Een logo of een tekening (PNG of JPG)",
   "step3.textLabel": "Jouw tekst",
   "step3.textHelp": "Maximaal {max} tekens. Letters, cijfers en eenvoudige leestekens.",
   "step3.counter": "{n}/{max}",
   "step3.textPlaceholder": "Bijv. Yanis",
   "step3.fontLabel": "Borduurlettertype",
   "step3.unsupported": "Sommige tekens worden niet ondersteund (emoji's, symbolen) en zijn verwijderd.",
   "step3.imageLabel": "Jouw afbeelding",
   "step3.drop": "Sleep je afbeelding hierheen",
   "step3.or": "of",
   "step3.pick": "Kies een bestand",
   "step3.imageRules": "PNG of JPG · maximaal {max} MB · minimaal {min} px aan de langste zijde",
   "step3.imageTips": "Kies bij voorkeur een scherp, eenvoudig logo of een tekening met weinig kleuren. Foto's, kleurverlopen en zeer gedetailleerde afbeeldingen zijn moeilijk te borduren: het PTB-team laat je weten of je motief haalbaar is.",
   "step3.imageNotProd": "Je bestand dient als referentie: het wordt niet ongewijzigd voor de productie gebruikt, het team past het aan voor het borduren.",
   "step3.replace": "Vervangen",
   "step3.delete": "Verwijderen",
   "step3.fileInfo": "{name} · {w}×{h} px · {size}",
   "step3.imageBusy": "Afbeelding wordt gelezen…",
   "step3.previewTitle": "Indicatieve voorvertoning",
   "step3.previewNote": "Indicatieve voorvertoning: het geborduurde resultaat kan licht afwijken (formaat, fijnheid van de details, garenkleur).",
   "step3.emptyPreview": "Jouw tekst",
   "step3.placementTitle": "Plaats van het borduurwerk",
   "step3.placementFor": "Plaats op {item}",
   "step3.sideNote": "Links en rechts: vanuit het standpunt van de persoon die het artikel draagt.",
   "step3.sameDesign": "Hetzelfde motief wordt op elk artikel van je aanvraag geborduurd. Je kunt voor elk soort artikel een andere plaats kiezen.",
   "step3.instrLabel": "Aanvullende instructies",
   "step3.instrHelp": "Aanpassingen, details over de plaatsing, zaken waarmee rekening moet worden gehouden…",
   "step3.needType": "Kies een tekst of afbeelding om door te gaan.",
   "step3.needText": "Voer je tekst in om door te gaan.",
   "step3.needImage": "Voeg een geldige afbeelding toe om door te gaan.",
   "step3.needPlacement": "Kies voor elk artikel een plaats.",
   "pl.chest_left": "Linkerborst",
   "pl.chest_right": "Rechterborst",
   "pl.chest_center": "Borst midden",
   "pl.back": "Rug",
   "pl.sleeve_left": "Linkermouw",
   "pl.sleeve_right": "Rechtermouw",
   "pl.front": "Voorkant",
   "pl.side_left": "Linkerzijde",
   "pl.side_right": "Rechterzijde",
   "pl.back_cap": "Achterkant",
   "pl.custom": "Andere (nader te bepalen)",
   "err.imgType": "Formaat wordt niet ondersteund. Gebruik een PNG- of JPG-bestand.",
   "err.imgSvg": "SVG-bestanden worden om veiligheidsredenen niet geaccepteerd. Exporteer je tekening als PNG.",
   "err.imgSize": "Bestand te groot ({size}). Maximum: {max}.",
   "err.imgSmall": "Afbeelding te klein ({w}×{h} px). Minimum: {min} px aan de langste zijde.",
   "err.imgLarge": "Afbeelding te groot qua afmetingen (maximaal {max} px).",
   "err.imgCorrupt": "Dit bestand kan niet worden gelezen. Controleer of het een intacte PNG- of JPG-afbeelding is.",
   "err.imgMismatch": "De inhoud van het bestand komt niet overeen met het formaat.",
   "step4.title": "Kies de kleuren van je borduurwerk.",
   "step4.sub": "Kies 1 tot {max} garenkleuren. De kleuren op het scherm zijn indicatief.",
   "step4.palette": "Garenpalet",
   "step4.count": "{n}/{max} kleur gekozen||{n}/{max} kleuren gekozen",
   "step4.selected": "Jouw garenkleuren",
   "step4.none": "Nog geen kleur gekozen.",
   "step4.max": "Maximum bereikt: {max} kleuren. Verwijder een kleur om een andere te kiezen.",
   "step4.need": "Kies minstens één garenkleur om door te gaan.",
   "step4.noteText": "De eerste kleur is die van de letters. De tweede, als je er een kiest, dient als omlijning in de voorvertoning.",
   "step4.noteImage": "Bij een meerkleurige afbeelding bevestigt het PTB-team het eindresultaat en het aantal garenkleuren.",
   "step4.indicative": "De tinten op het scherm zijn indicatief: de echte garens kunnen licht afwijken.",
   "step4.code": "Ref. {code}",
   "step4.removeOne": "{name} verwijderen",
   "step5.title": "Controleer en verstuur je aanvraag.",
   "step5.sub": "Lees je project nog eens na. Zodra je aanvraag is verzonden, bevestig je die via de beveiligde Shopify-betaling: ons team verwerkt de aanvraag na die bevestiging.",
   "step5.subReq": "Lees je project nog eens na. Dit is een personalisatieaanvraag: er wordt nu geen betaling gevraagd.",
   "step5.afterSend": "Na het verzenden ga je naar de beveiligde Shopify-betaling om je aanvraag te bevestigen. De prijzen zijn die van de winkel, zonder toeslag voor borduurwerk en zonder packkorting.",
   "step5.markerNote": "Bij de betaling zie je een regel „Atelier PTB — Geborduurde personalisatie (zonder toeslag)” van 0 €: die dient voor de opvolging van je aanvraag en voegt niets toe aan de prijs van je artikelen.",
   "step5.preparing": "Betaling wordt voorbereid…",
   "step5.sendShort": "Verzenden",
   "step5.items": "Jouw artikel en de personalisatie ervan",
   "step5.design": "Jouw personalisatie",
   "step5.designText": "Tekst: „{text}”",
   "step5.designImage": "Afbeelding: {name}",
   "step5.fontL": "Lettertype",
   "step5.threadsL": "Borduurgarens",
   "step5.placementL": "Plaats",
   "step5.instrL": "Instructies",
   "step5.edit": "Wijzigen",
   "step5.contact": "Jouw contactgegevens",
   "f.first": "Voornaam",
   "f.last": "Achternaam",
   "f.email": "E-mail",
   "f.phone": "Telefoon (optioneel)",
   "f.message": "Bericht voor het team (optioneel)",
   "f.messageHelp": "Een verduidelijking, een gewenste datum, een vraag…",
   "step5.shipTo": "Geschatte verzending naar: {country}. Je kunt het land wijzigen via het menu van de site.",
   "step5.consent": "Ik bevestig dat deze gegevens juist zijn en dat ik het recht heb de aangeleverde tekst of afbeelding te gebruiken. Ik begrijp dat mijn aanvraag via de beveiligde Shopify-betaling wordt bevestigd.",
   "step5.consentReq": "Ik bevestig dat deze gegevens juist zijn en dat ik het recht heb de aangeleverde tekst of afbeelding te gebruiken. Ik begrijp dat dit een aanvraag is en geen bestelling: er wordt nu geen betaling gevraagd.",
   "step5.privacy": "Je contactgegevens, je project en je bestand worden uitsluitend gebruikt om je aanvraag te verwerken. Het bestand wordt bewaard in een privéomgeving die alleen voor het PTB-team toegankelijk is,",
   "step5.privacyText": "Je contactgegevens en je project worden uitsluitend gebruikt om je aanvraag te verwerken.",
   "step5.retention": "en daarna na {n} maand verwijderd.||en daarna na {n} maanden verwijderd.",
   "step5.privacyLink": "Privacybeleid",
   "step5.send": "Mijn aanvraag verzenden",
   "step5.sending": "Verzenden…",
   "step5.previewMode": "Voorbeeldmodus: verzenden is uitgeschakeld totdat de dienst voor het ontvangen van aanvragen is ingesteld. Er wordt niets verzonden.",
   "step5.disabled": "Het verzenden van aanvragen is nog niet beschikbaar. Er is geen aanvraag verzonden.",
   "err.first": "Geef je voornaam op.",
   "err.last": "Geef je achternaam op.",
   "err.email": "Geef een geldig e-mailadres op.",
   "err.phone": "Dit telefoonnummer lijkt niet geldig.",
   "err.consent": "Vink het bevestigingsvakje aan om je aanvraag te verzenden.",
   "err.stepsIncomplete": "Een vorige stap is onvolledig: {step}.",
   "err.send.network": "Verbinding niet mogelijk. Controleer je verbinding: je gegevens blijven bewaard, je kunt het opnieuw proberen.",
   "err.send.server": "Het verzenden is niet gelukt. Je gegevens blijven bewaard, je kunt het zo meteen opnieuw proberen.",
   "err.send.rate": "Te veel aanvragen in korte tijd. Probeer het over enkele minuten opnieuw.",
   "err.send.invalid": "De aanvraag kon niet worden geaccepteerd: {msg}",
   "err.send.spam": "De aanvraag is geweigerd door de spamcontrole. Laad de pagina opnieuw en probeer het nogmaals.",
   "err.send.cart": "De betaling kon niet worden voorbereid ({msg}). Controleer je artikelen en probeer het opnieuw: er is niets verzonden.",
   "err.send.contact": "Blijft het probleem bestaan, schrijf ons dan via de contactpagina.",
   "err.send.contactLink": "Contactpagina",
   "ok.title": "Bedankt voor je personalisatieaanvraag!",
   "ok.body": "We hebben je project ontvangen. Ons team bekijkt de details van je borduurwerk en neemt per e-mail contact met je op.",
   "ok.ref": "Referentie van je aanvraag",
   "ok.mailSent": "Er is zojuist een bevestigingsmail naar {email} gestuurd. Vergeet niet ook je spammap te controleren.",
   "ok.mailSentPay": "Er is zojuist een bevestigingsmail met de link om je aanvraag te bevestigen naar {email} gestuurd.",
   "ok.last": "Laatste stap: bevestig je aanvraag",
   "ok.lastText": "Zodat wij haar kunnen verwerken, rond je bestelling af via de beveiligde Shopify-betaling. Prijzen van de winkel, zonder toeslag voor borduurwerk en zonder packkorting.",
   "ok.pay": "Mijn aanvraag bevestigen",
   "ok.redirect": "Doorverwijzing naar de beveiligde betaling…",
   "ok.mailFailed": "Je aanvraag is geregistreerd, maar de bevestigingsmail kon niet worden verzonden. Bewaar deze referentie goed.",
   "ok.next": "En daarna?",
   "ok.n1": "Je bevestigt je aanvraag via de beveiligde Shopify-betaling.",
   "ok.n2": "Ons team bekijkt de details van je borduurwerk: haalbaarheid, formaat, garenkleuren.",
   "ok.n3": "Als er iets verduidelijkt moet worden, neemt het team per e-mail contact met je op.",
   "ok.q1": "Het team bekijkt je project: haalbaarheid, formaat van het borduurwerk, garenkleuren.",
   "ok.q2": "Je ontvangt een antwoord per e-mail, met eventuele verduidelijkingen.",
   "ok.q3": "Er wordt niets besteld of betaald vóór jouw bevestiging.",
   "co.custom": "Personalisatie",
   "co.font": "Lettertype",
   "co.threads": "Garens",
   "co.place": "Plaats",
   "co.instr": "Instructies",
   "co.ref": "Aanvraag",
   "ok.new": "Nog een aanvraag indienen",
   "ok.shop": "Terug naar de winkel",
   "step2.perArticle": "Elke regel is een artikel met zijn eigen personalisatie in de volgende stap. Om twee verschillende motieven te borduren, voeg je twee regels toe („Nog een maat of kleur toevoegen”).",
   "line.n": "Artikel {n}",
   "step3.subMulti": "Kies een personalisatie voor elk artikel, of dezelfde voor alle. De voorvertoning is indicatief.",
   "mode.label": "Reikwijdte van de personalisatie",
   "mode.same": "Dezelfde personalisatie voor alle",
   "mode.sameHelp": "Hetzelfde motief op alle {n} artikelen.",
   "mode.each": "Eén personalisatie per artikel",
   "mode.eachHelp": "Tekst of afbeelding, garens en plaats per artikel.",
   "mode.confirmTitle": "Bevestigen",
   "mode.confirm": "De personalisaties per artikel worden vervangen door die van artikel 1. Doorgaan?",
   "mode.confirmYes": "Ja, op alle toepassen",
   "common.cancel": "Annuleren",
   "tabs.label": "Artikelen van je aanvraag",
   "copy.label": "Kopieer de personalisatie van een ander artikel",
   "copy.labelThreads": "Kopieer de garens van een ander artikel",
   "copy.choose": "Kies een artikel…",
   "step3.scopeSame": "Deze personalisatie wordt op elk van de {n} artikelen van je aanvraag geborduurd (de plaats blijft per artikel instelbaar).",
   "step3.scopeEach": "Je personaliseert: {n}.",
   "step3.qtyNote": "Aantal: {n} — hetzelfde borduurwerk wordt op elk stuk gemaakt.",
   "step3.oneDesign": "Kies de plaats van het borduurwerk.",
   "step5.itemsMany": "Jouw artikelen en hun personalisatie",
   "step5.editDesign": "Personalisatie wijzigen",
   "step5.editThreads": "Garens wijzigen",
   "co.item": "Artikel",
   "size.legend": "Formaat van het borduurwerk — {item}",
   "size.auto": "Laat het aan ons over",
   "size.custom": "Ik geef het formaat aan",
   "size.helpAuto": "Wij kiezen het formaat voor het beste resultaat, afhankelijk van de plaats en je motief.",
   "size.hintCustom": "Geef de breedte en hoogte van het afgewerkte borduurwerk aan, in cm ({min} tot {max}). We controleren de haalbaarheid en nemen contact met je op als een aanpassing nodig is.",
   "size.w": "Breedte (cm)",
   "size.h": "Hoogte (cm)",
   "size.sum": "Borduurwerk van ongeveer {size}. We controleren de haalbaarheid en nemen contact met je op als een aanpassing nodig is.",
   "size.ratio": "De verhoudingen van je afbeelding blijven behouden: de andere afmeting wordt automatisch berekend.",
   "size.errBoth": "Geef de breedte en hoogte (in cm) op, of kies „Laat het aan ons over”.",
   "size.errRange": "De afmetingen moeten tussen {min} en {max} cm liggen.",
   "size.fmt": "{w} × {h} cm",
   "size.fmtLong": "{w} × {h} cm (breedte × hoogte)",
   "size.autoShort": "Laat het aan ons over",
   "size.autoLong": "Laat het aan ons over — het atelier kiest het formaat",
   "co.size": "Formaat van het borduurwerk",
   "step5.sizeL": "Formaat van het borduurwerk"
  };
  A.i18n.threadNames = {"PTB-01": {"es": "Negro", "de": "Schwarz", "it": "Nero", "nl": "Zwart"}, "PTB-02": {"es": "Blanco", "de": "Weiß", "it": "Bianco", "nl": "Wit"}, "PTB-03": {"es": "Marfil", "de": "Elfenbein", "it": "Avorio", "nl": "Ivoor"}, "PTB-04": {"es": "Oro", "de": "Gold", "it": "Oro", "nl": "Goud"}, "PTB-05": {"es": "Plata", "de": "Silber", "it": "Argento", "nl": "Zilver"}, "PTB-06": {"es": "Gris antracita", "de": "Anthrazit", "it": "Grigio antracite", "nl": "Antraciet"}, "PTB-07": {"es": "Rojo", "de": "Rot", "it": "Rosso", "nl": "Rood"}, "PTB-08": {"es": "Burdeos", "de": "Bordeauxrot", "it": "Bordeaux", "nl": "Bordeauxrood"}, "PTB-09": {"es": "Rosa", "de": "Rosa", "it": "Rosa", "nl": "Roze"}, "PTB-10": {"es": "Fucsia", "de": "Fuchsia", "it": "Fucsia", "nl": "Fuchsia"}, "PTB-11": {"es": "Naranja", "de": "Orange", "it": "Arancione", "nl": "Oranje"}, "PTB-12": {"es": "Amarillo", "de": "Gelb", "it": "Giallo", "nl": "Geel"}, "PTB-13": {"es": "Verde claro", "de": "Hellgrün", "it": "Verde chiaro", "nl": "Lichtgroen"}, "PTB-14": {"es": "Verde esmeralda", "de": "Smaragdgrün", "it": "Verde smeraldo", "nl": "Smaragdgroen"}, "PTB-15": {"es": "Verde bosque", "de": "Waldgrün", "it": "Verde foresta", "nl": "Bosgroen"}, "PTB-16": {"es": "Caqui", "de": "Khaki", "it": "Cachi", "nl": "Kaki"}, "PTB-17": {"es": "Turquesa", "de": "Türkis", "it": "Turchese", "nl": "Turquoise"}, "PTB-18": {"es": "Azul cielo", "de": "Himmelblau", "it": "Azzurro cielo", "nl": "Hemelsblauw"}, "PTB-19": {"es": "Azul royal", "de": "Königsblau", "it": "Blu reale", "nl": "Koningsblauw"}, "PTB-20": {"es": "Azul marino", "de": "Marineblau", "it": "Blu navy", "nl": "Marineblauw"}, "PTB-21": {"es": "Violeta", "de": "Violett", "it": "Viola", "nl": "Paars"}, "PTB-22": {"es": "Marrón", "de": "Braun", "it": "Marrone", "nl": "Bruin"}, "PTB-23": {"es": "Beige", "de": "Beige", "it": "Beige", "nl": "Beige"}, "PTB-24": {"es": "Camel", "de": "Camel", "it": "Cammello", "nl": "Camel"}};
})();
